import { render, staticRenderFns } from "./UpdatePickListOrder.vue?vue&type=template&id=24c85ce6"
import script from "./UpdatePickListOrder.vue?vue&type=script&lang=js"
export * from "./UpdatePickListOrder.vue?vue&type=script&lang=js"
import style0 from "./UpdatePickListOrder.vue?vue&type=style&index=0&id=24c85ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports